import { render, staticRenderFns } from "./iframeLayout.vue?vue&type=template&id=3f53d6d4"
import script from "./iframeLayout.vue?vue&type=script&lang=js"
export * from "./iframeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports